/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from "react";
import axios from "axios";
import { Badge, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../../../config.json";
import imgVide from "../../../../../assets/images/vide.png";
import "../../../../../i18n";
import { useTranslation } from "react-i18next";
import { formatDualMoney } from "../../../../../utils/currency";
import ProductMetaDisplay from "../../../shared/ProductMetaDisplay";
import ProductShareModal from "./ProductShareModal";
import { productTitle } from "../../../Cms/MenuTree/menuTreeUtils";

const Products = ({ product, fetchProducts }) => {
  const { t } = useTranslation();
  const {
    _id,
    price,
    secondaryPrice,
    photos = [],
    productDetails = [],
    isArchived,
    productBadges = [],
    nutritionValues = [],
    productBadge = "",
  } = product;
  const [shareOpen, setShareOpen] = useState(false);

  const hideProduct = async () => {
    try {
      await axios.put(`${config.dev}/v2/products/hide/${_id}`);
      swal("SUCCESS", "Product is in hide mode", "success");
      fetchProducts();
    } catch (error) {
      swal("ERROR", "" + error, "error");
    }
  };

  if (isArchived) return null; // <-- ici on ne rend rien

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className="card kitchen-card">
        <div className="card-body">
          <div className="new-arrival-product">
            <div className="kitchen-card__top">
              <div className="basic-dropdown kitchen-card__menu">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-secondary"
                    className="btn-sm"
                    id="product-actions"
                  >
                    <i className="fas fa-ellipsis-v" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      as={Link}
                      to={`/product-sheet/${_id}`}
                      className="kitchen-action-view"
                    >
                      <i className="fas fa-eye me-2" />
                      {t("details")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      as={Link}
                      to={`/edit-product/${_id}`}
                      className="text-danger-yellow"
                    >
                      <i className="fas fa-pen me-2 text-danger-yellow" />
                      {t("edit")}
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => setShareOpen(true)}
                      className="text-info"
                    >
                      <i className="fas fa-share-alt me-2 text-info" />
                      {t("productActionShare")}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={hideProduct} className="text-danger-dark">
                      <i className="fas fa-archive me-2 text-danger-dark" />
                      {t("archive")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            <div className="new-arrivals-img-contnent product-card-image-wrap kitchen-card__media">
              <img
                className="img-fluid kitchen-card__photo"
                src={
                  photos.length > 0
                    ? `${config.UPLOADS_SERVER}/product/${photos[0]}`
                    : imgVide
                }
                alt="product"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = imgVide;
                }}
              />
              <ProductMetaDisplay
                productBadges={productBadges}
                legacyProductBadge={productBadge}
                variant="overlay"
              />
            </div>

            <div className="new-arrival-content kitchen-card__title">
              <h4>
                <Link>
                  {productTitle({ productDetails })}
                </Link>
              </h4>
              <div className="kitchen-card__meta">
                {formatDualMoney(price || 0, secondaryPrice)}
              </div>
              <ProductMetaDisplay
                nutritionValues={nutritionValues}
                variant="inline"
              />
            </div>
          </div>
        </div>
      </div>

      <ProductShareModal
        open={shareOpen}
        product={product}
        onClose={() => setShareOpen(false)}
        t={t}
      />
    </div>
  );
};

export default Products;
